webpackJsonp([54314933751126],{

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border: 1px solid #8cd0c5;\n  border-radius: 3px;\n  color: #8cd0c5;\n  cursor: pointer;\n  display: inline-block;\n  font-family: \"Greek\", \"Source Sans Pro\";\n  font-size: 0.6875em;\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-bottom: 0.625em;\n  margin-right: 0.375em;\n  padding: 0.125em 0.55em 0em 0.5em;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: all 0.4s ease;\n  user-select: none;\n\n  @media screen and (max-width: 550px) {\n    font-size: 0.792em;\n  }\n\n  @media screen and (max-width: 450px) {\n    font-size: 0.896em;\n  }\n\n  &:hover {\n    background-color: rgba(140, 208, 197, 0.2);\n  }\n\n  .fa-check {\n    margin-right: 6px;\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid #8cd0c5;\n  border-radius: 3px;\n  color: #8cd0c5;\n  cursor: pointer;\n  display: inline-block;\n  font-family: \"Greek\", \"Source Sans Pro\";\n  font-size: 0.6875em;\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-bottom: 0.625em;\n  margin-right: 0.375em;\n  padding: 0.125em 0.55em 0em 0.5em;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: all 0.4s ease;\n  user-select: none;\n\n  @media screen and (max-width: 550px) {\n    font-size: 0.792em;\n  }\n\n  @media screen and (max-width: 450px) {\n    font-size: 0.896em;\n  }\n\n  &:hover {\n    background-color: rgba(140, 208, 197, 0.2);\n  }\n\n  .fa-check {\n    margin-right: 6px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  border: none !important;\n  display: inline-block !important;\n  margin-right: 0.4375em !important;\n  margin-top: 0px !important;\n  padding-left: 0.25em;\n  position: relative;\n  top: 0.5em;\n  vertical-align: middle;\n  width: 1.2em;\n\n  @media screen and (max-width: 550px) {\n    top: 0.5625em;\n  }\n\n  @media screen and (max-width: 450px) {\n    top: 0.5em;\n  }\n"], ["\n  border: none !important;\n  display: inline-block !important;\n  margin-right: 0.4375em !important;\n  margin-top: 0px !important;\n  padding-left: 0.25em;\n  position: relative;\n  top: 0.5em;\n  vertical-align: middle;\n  width: 1.2em;\n\n  @media screen and (max-width: 550px) {\n    top: 0.5625em;\n  }\n\n  @media screen and (max-width: 450px) {\n    top: 0.5em;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  background-image: none !important;\n"], ["\n  background-image: none !important;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkSolid = __webpack_require__(1575);
	
	var _checkSolid2 = _interopRequireDefault(_checkSolid);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(27);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Button = _styledComponents2.default.div(_templateObject, _colors2.default.background);
	
	var Checkmark = _styledComponents2.default.img(_templateObject2);
	
	var Link = _styledComponents2.default.a(_templateObject3);
	
	exports.default = function (_ref) {
	  var lines = _ref.lines,
	      url = _ref.url;
	
	  return _react2.default.createElement(
	    Link,
	    { href: "https://www.youtube.com/watch?v=" + url },
	    _react2.default.createElement(
	      Button,
	      null,
	      _react2.default.createElement(Checkmark, { src: _checkSolid2.default }),
	      "regels ",
	      lines
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  margin-bottom: -10px;\n  padding-top: 7px;\n\n  @media print {\n    display: none;\n  }\n"], ["\n  display: block;\n  margin-bottom: -10px;\n  padding-top: 7px;\n\n  @media print {\n    display: none;\n  }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styledComponents2.default.div(_templateObject);
	module.exports = exports["default"];

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n&:before {\n  content: '", "';\n  position: absolute;\n  left: -3.125em;\n  top: 0px;\n\n      @media print {\n      top: -11px;\n    }\n}\n"], ["\n  position: relative;\n\n&:before {\n  content: '", "';\n  position: absolute;\n  left: -3.125em;\n  top: 0px;\n\n      @media print {\n      top: -11px;\n    }\n}\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledSpan = _styledComponents2.default.span(_templateObject, function (props) {
	  return props.n;
	});
	
	exports.default = function (_ref) {
	  var n = _ref.n,
	      children = _ref.children;
	  return _react2.default.createElement(
	    StyledSpan,
	    { n: n },
	    children
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: table;\n  margin: 2em auto;\n  padding-left: 2.5em;\n  position: relative;\n\n  > p {\n    margin: 0px;\n\n    @media print {\n      line-height: 2.8;\n    }\n  }\n"], ["\n  display: table;\n  margin: 2em auto;\n  padding-left: 2.5em;\n  position: relative;\n\n  > p {\n    margin: 0px;\n\n    @media print {\n      line-height: 2.8;\n    }\n  }\n"]);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styledComponents2.default.div(_templateObject);
	module.exports = exports["default"];

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 0.9em;\n  font-weight: 400;\n  letter-spacing: 0px;\n  list-style: none;\n  margin: 0;\n  padding: 0 !important;\n  text-transform: none;\n\n  & + h2 {\n    margin-top: 2em;\n  }\n\n  > li {\n    line-height: 1.3em;\n    margin-top: 0.55em;\n    padding-left: 0px !important;\n  }\n"], ["\n  color: ", ";\n  font-size: 0.9em;\n  font-weight: 400;\n  letter-spacing: 0px;\n  list-style: none;\n  margin: 0;\n  padding: 0 !important;\n  text-transform: none;\n\n  & + h2 {\n    margin-top: 2em;\n  }\n\n  > li {\n    line-height: 1.3em;\n    margin-top: 0.55em;\n    padding-left: 0px !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 2em;\n"], ["\n  margin-bottom: 2em;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(121);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(27);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// The same styling as in the /grammatica/Wrapper/ component
	var List = _styledComponents2.default.ul(_templateObject, _colors2.default.main);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	exports.default = function (_ref) {
	  var book = _ref.book,
	      chapter = _ref.chapter;
	
	  var latinNoGrammar = [13, 19, 20, 27, 34, 41, 47, 48, 53, 55];
	  var greekNoGrammar = [];
	
	  var grammarlessChapters = book == "spqr" ? latinNoGrammar : greekNoGrammar;
	
	  return _react2.default.createElement(
	    Container,
	    { id: "vooraf", "class": "noprint" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Voordat ik begin"
	    ),
	    _react2.default.createElement(
	      List,
	      null,
	      grammarlessChapters.includes(chapter) ? null : _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "../" + chapter + "._grammatica" },
	          "Heb ik alle leerdoelen voor dit hoofdstuk behaald?"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          {
	            href: book == "spqr" ? "https://www.memrise.com/course/1616616/spqr/" : "https://www.memrise.com/course/1616658/argo/"
	          },
	          "Ken ik ten minste de eerste 10 woordjes van les ",
	          chapter,
	          "?"
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 1575:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJjaGVjayIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLWNoZWNrIGZhLXctMTYiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHBhdGggZmlsbD0iIzhjZDBjNSIgZD0iTTE3My44OTggNDM5LjQwNGwtMTY2LjQtMTY2LjRjLTkuOTk3LTkuOTk3LTkuOTk3LTI2LjIwNiAwLTM2LjIwNGwzNi4yMDMtMzYuMjA0YzkuOTk3LTkuOTk4IDI2LjIwNy05Ljk5OCAzNi4yMDQgMEwxOTIgMzEyLjY5IDQzMi4wOTUgNzIuNTk2YzkuOTk3LTkuOTk3IDI2LjIwNy05Ljk5NyAzNi4yMDQgMGwzNi4yMDMgMzYuMjA0YzkuOTk3IDkuOTk3IDkuOTk3IDI2LjIwNiAwIDM2LjIwNGwtMjk0LjQgMjk0LjQwMWMtOS45OTggOS45OTctMjYuMjA3IDkuOTk3LTM2LjIwNC0uMDAxeiI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rehypeReact = __webpack_require__(187);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Helmet = __webpack_require__(72);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _Button = __webpack_require__(685);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(686);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _ExtraTip = __webpack_require__(191);
	
	var _ExtraTip2 = _interopRequireDefault(_ExtraTip);
	
	var _Linenumber = __webpack_require__(687);
	
	var _Linenumber2 = _interopRequireDefault(_Linenumber);
	
	var _Text = __webpack_require__(688);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Tip = __webpack_require__(26);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	var _Vooraf = __webpack_require__(689);
	
	var _Vooraf2 = _interopRequireDefault(_Vooraf);
	
	var _Wrapper = __webpack_require__(192);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var renderAst = new _rehypeReact2.default({
	  createElement: _react2.default.createElement,
	  components: {
	    btn: _Button2.default,
	    buttons: _Buttons2.default,
	    l: _Linenumber2.default,
	    t: _Tip2.default,
	    text: _Text2.default,
	    x: _ExtraTip2.default
	  }
	}).Compiler;
	
	var Title = _styledComponents2.default.h1(_templateObject);
	
	var Post = _styledComponents2.default.div(_templateObject);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  var _post$frontmatter = post.frontmatter,
	      book = _post$frontmatter.book,
	      chapter = _post$frontmatter.chapter,
	      title = _post$frontmatter.title;
	
	  return _react2.default.createElement(
	    _Wrapper2.default,
	    null,
	    _react2.default.createElement(_Helmet2.default, { data: data }),
	    _react2.default.createElement(
	      Title,
	      null,
	      title
	    ),
	    book == "lego" ? _react2.default.createElement("div", null) : book == "argo" ? _react2.default.createElement("div", null) : book == "spqr" ? _react2.default.createElement(_Vooraf2.default, { book: book, chapter: chapter }) : _react2.default.createElement("div", null),
	    _react2.default.createElement(
	      Post,
	      null,
	      renderAst(post.htmlAst)
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tekst-js-fced5e42a3e58ab56e34.js